import { render, staticRenderFns } from "./Bootstrap-5.vue?vue&type=template&id=39db60ce&"
import script from "./Bootstrap-5.vue?vue&type=script&lang=js&"
export * from "./Bootstrap-5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports